import {initWebComponent} from "@/helpers/web-component-helper";
import {loadInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {removeAllActiveClasses} from "@/helpers/layer-menu-helper";
import {closeInfoMenu} from "@/helpers/layer/info/layer-info-helper";

export class LayerMenuButtonInfoComponent extends HTMLElement{
    constructor(){
        super();
        let label = this.closest('layer-menu-group-item')
        if(label){
            label = label.dataset.label
        } else {
            label = ''
        }

        if(label === '') {
            label = this.getAttribute('data-label')
        }

        const className = this.getAttribute('data-class-name')

        const template = document.createElement('template');
        template.innerHTML =
            `<button title="Open kenmerken van: ${label}" class="btn btn-sm borderless icon-btn text-transform-none btn-characteristics ` + className + `">
    <span class="fa fa-tag"></span>
</button>`;

        initWebComponent(this, template)

        const id = this.getAttribute('data-id')

        this.addEventListener('click', () => {

            const button = this.querySelector('button')
            if(button.classList.contains('active')) {
                closeInfoMenu('layer-info-characteristics')
            } else {
                removeAllActiveClasses()
                button.classList.add('active')
                loadInfoCharacteristics(id)
            }
        });
    }
}
